import ActionsComponent from './ActionsComponent';

export default ActionsComponent;
